import {
  getActiveUser,
  navigate,
  sendGetRequest,
  formatDate,
  getUserStatus,
  sendDeleteRequest,
  watchLiveData,
  allowedOperations
} from "../utils/utils";
import DataListWithSearch from "./component/@list/list-search";
import { useState, useEffect } from "react";
import AppRoutes from "../routing/routes";
import { useSelector } from "react-redux";

const getTableHead = () => {
  return [
    { id: "createdAt", label: "Created On", alignRight: false },
    { id: "code", label: "Code", alignRight: false },
    { id: "name", label: "Name", alignRight: false }];
};

const startEdit = (uuid) => navigate(`${ AppRoutes.contents }/${AppRoutes.subject}${uuid ? `?uuid=${uuid}` : ''}`, true);


const SubjectsList = () => {
  const loggedUser = getActiveUser();
  const [dataList, setDataList] = useState([]);
  const [loading, onLoading] = useState(false);
  const { queue } = useSelector((state) => state.queue);
  const { canEdit, canDelete, canCreate } = allowedOperations();

  const userOptions = [
    canDelete ? {
      icon: "delete",
      value: "delete",
      label: "Delete",
      onClick: (value, selected) => {
        onLoading(true);
        Promise.all(selected.map(uuid => sendDeleteRequest('subjects', uuid))).then(response => {
          executeFetch();
        })
      }
    }: null,
    canEdit ? {
      icon: "edit",
      value: "edit",
      label: "Edit",
      onClick: (_value, selected) => startEdit(selected),
    }: null,
    
  ].filter(Boolean);
  const filterOptions = [];

  const executeFetch = () => {
    sendGetRequest('subjects?metadata=true', (loading) => onLoading(loading),
      (data) => setDataList(data));
  };


  useEffect(
    () => executeFetch(),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [loggedUser.email]
  );

  useEffect(() => {
      if (queue) watchLiveData(queue, "subjects", (_) => executeFetch(true));
      // eslint-disable-next-line
    }, [queue]);


  return (
    <div>
      <DataListWithSearch
        sectionTitle="Subjects"
        createNewLabel={canCreate ? "Add Subject": null}
        data={dataList}
        primaryKey="uuid"
        filterColumn={"name"}
        emptyIcon="subject"
        avatarKey="uuid"
        loading={loading}
        onCreateNewItem={() => startEdit()}
        headers={getTableHead()}
        onBack={() =>
          navigate(`${AppRoutes.contents}`, true)
        }
        rowData={(data) => {
          const _entries = [
            { value: formatDate(data.createdAt), width: 200 },
            {
              value: `${data.code}`,
              width: 160,
            },
            { value: data.name }
          ];
          return {
            exclude: [],
            entries: _entries,
          };
        }}
        selectionOptions={userOptions.filter((option) => option.value !== "edit")}
        filterOptions={filterOptions}
        optionItems={userOptions}
      />

    </div>
  );
};

export default SubjectsList;